import styled from "styled-components";
import { StatusEmissao } from "../../../../enums/StatusEmissaoEnum";

interface PropsContainer {
  statusEmissao: StatusEmissao;
}

const colorStrategy = (theme: any) => {
  return {
    PROCESSANDO: {
      backgroundColor: theme.colors.tags.warning.bgColor,
      border: theme.colors.tags.warning.textColor,
      color: theme.colors.tags.warning.textColor,
    },
    EMITIDO: {
      backgroundColor: theme.colors.tags.success.bgColor,
      border: theme.colors.tags.success.textColor,
      color: theme.colors.tags.success.textColor,
    },
    FALHA: {
      backgroundColor: theme.colors.tags.danger.bgColor,
      border: theme.colors.tags.danger.textColor,
      color: theme.colors.tags.danger.textColor,
    },
    DADOS_INCONSISTENTES: {
      backgroundColor: theme.colors.tags.warning03.bgColor,
      border: theme.colors.tags.warning03.textColor,
      color: theme.colors.tags.warning03.textColor,
    },
    EXERCICIO_INDISPONIVEL: {
      backgroundColor: theme.colors.tags.warning03.bgColor,
      border: theme.colors.tags.warning03.textColor,
      color: theme.colors.tags.warning03.textColor,
    },
  };
};

export const Container = styled.button<PropsContainer>`
  border-radius: 15px;
  width: 150px;
  height: 24px;
  text-align: center;
  background-color: ${({ statusEmissao, theme }) =>
    colorStrategy(theme)[statusEmissao].backgroundColor};
  border: solid 1px
    ${({ statusEmissao, theme }) => colorStrategy(theme)[statusEmissao].border};
  color: ${({ statusEmissao, theme }) =>
    colorStrategy(theme)[statusEmissao].color};

  &:hover {
    cursor: default;
  }
`;
